(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["template--cart"]) return;
  try {
    
  document.querySelectorAll('.js-bundle-remove').forEach(button => {
    button.addEventListener('click', async () => {
      const ids = button.dataset.lineIds.split(',').filter(id => !!id)
      const updates = {}
      ids.forEach(id => updates[id] = 0)

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(res => res.json())

      window.location.reload()
    })
  })

  } catch(e) { console.error(e); }
})();
})();
